import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import dateformat from 'dateformat';

import { fetchPressReleaseByPage } from '../../../lib/actions';
import { ARTICLE_TYPE } from '../press-article/press-article';

class ArchiveBrowser extends Component {
  constructor(props) {
    super(props);

    this.renderArticle = this.renderArticle.bind(this);
    this.handleMore = this.handleMore.bind(this);
    this.handlePrevious = this.handlePrevious.bind(this);
    this.renderBrowserContainer = this.renderBrowserContainer.bind(this);

    this.state = {
      page: 0,
      pages: [this.renderBrowserContainer(props.articles[0], 0)],
    };
  }

  // componentWillReceiveProps(nextProps) {
  //   const { pages } = this.state;
  //   const nextArticles = nextProps.articles;

  //   if (nextArticles.length !== this.props.articles.length) {
  //     const page = nextArticles.length - 1;

  //     pages[page] = this.renderBrowserContainer(nextArticles[page], page);

  //     this.setState({
  //       pages,
  //       page,
  //     });
  //   }
  // }

  componentDidMount() {
    const { dispatch, archiveType, totalPages } = this.props;
    let page = 0;

    while (page < totalPages - 1) {
      page++; // eslint-disable-line no-plusplus
      dispatch(
        fetchPressReleaseByPage({
          pressReleaseType: archiveType,
          page,
        })
      );
    }
  }

  handleMore() {
    const { articles, dispatch, archiveType } = this.props;
    const { pages } = this.state;
    let { page } = this.state;

    page++; // eslint-disable-line no-plusplus

    if (articles.length > page) {
      pages.push(this.renderBrowserContainer(articles[page], page));

      this.setState({
        pages,
        page,
      });
    } else {
      dispatch(
        fetchPressReleaseByPage({
          pressReleaseType: archiveType,
          page,
        })
      );
    }
  }

  handlePrevious() {
    let { page } = this.state;

    page--; // eslint-disable-line no-plusplus

    this.setState({
      page,
    });
  }

  /* eslint-disable class-methods-use-this */
  formatDate(date) {
    return dateformat(date, 'mmmm d, yyyy');
  }
  /* eslint-enable class-methods-use-this */

  renderBrowserContainer(articles, i) {
    return (
      <ul key={i} className="archive-browser__box">
        {_.map(articles, this.renderArticle)}
      </ul>
    );
  }

  /* eslint-disable class-methods-use-this */
  renderSource(article) {
    const { link, type, mediaSite } = article;
    const mediaSiteName = mediaSite && mediaSite.name;

    if (type === ARTICLE_TYPE.EXTERNAL && mediaSiteName) {
      return (
        <span>
          <a href={link} target="_blank" rel="noopener noreferrer">
            {mediaSiteName}
          </a>
          ,{' '}
        </span>
      );
    }

    return null;
  }
  /* eslint-enable class-methods-use-this */

  renderArticle(article, i) {
    const { date, link, title } = article;
    const getTitleHTML = () => ({ __html: title });

    return (
      <li key={i}>
        <span className="archive-browser__info">
          {this.renderSource(article)}
          {this.formatDate(date)}
        </span>
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label -- directive added automatically by Shepherd migration */}
        <a
          className="archive-browser__title"
          href={link}
          // eslint-disable-next-line react/no-danger -- directive added automatically by Shepherd migration
          dangerouslySetInnerHTML={getTitleHTML()}
          target="_blank"
          rel="noopener noreferrer"
        />
      </li>
    );
  }

  render() {
    const { totalPages } = this.props;
    const { pages, page } = this.state;
    const containerStyle = {
      transform: `translate(-${page * 100}%)`,
    };

    /* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
    let previousLink = null;
    if (page > 0) {
      previousLink = (
        <a className="archive-browser__previous" onClick={this.handlePrevious}>
          &larr; PREVIOUS
        </a>
      );
    }
    let nextLink = null;
    if (page < totalPages - 1) {
      nextLink = (
        <a className="archive-browser__next" onClick={this.handleMore}>
          MORE STORIES &rarr;
        </a>
      );
    }
    /* eslint-enable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */

    return (
      <section className="archive-browser">
        <div className="archive-browser__scroller">
          <div className="archive-browser__container" style={containerStyle}>
            {pages}
          </div>
        </div>
        <div className="archive-browser__more">
          {previousLink}
          {nextLink}
        </div>
      </section>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
ArchiveBrowser.propTypes = {
  articles: PropTypes.array.isRequired,
  totalPages: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
  archiveType: PropTypes.string.isRequired,
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
ArchiveBrowser.displayName = 'ArchiveBrowser';

export default ArchiveBrowser;
